import { observer } from 'mobx-react-lite';
import qs from 'qs';
import { ReactElement, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ACDLError } from '../../../models/error.model';
import { useAuthService } from '../auth.service';
import { ConfirmNewEmail } from '../components/emailConfirmation/ConfirmNewEmail';

export const ConfirmNewEmailContainer = observer((): ReactElement => {
  const authService = useAuthService();

  const [confirmationStatus, setConfirmationStatus] = useState<'InProgress' | 'Failed' | 'Success'>('InProgress');
  const location = useLocation();
  const history = useHistory();

  const confirmNewEmail = async (): Promise<void> => {
    setConfirmationStatus('InProgress');
    const parsedSearch = qs.parse(location.search.slice(1)) as { email: string; token: string };

    const result = await authService.confirmNewEmail({ email: parsedSearch.email, token: parsedSearch.token });

    if (result instanceof ACDLError) {
      setConfirmationStatus('Failed');
    } else {
      setConfirmationStatus('Success');

      setTimeout(() => {
        authService.logout();
        history.push('/login'); // redirect to login after logout
      }, 10000);
    }
  };

  const handleGoToLoginClick = (): void => {
    authService.logout();
    history.push('/login'); // redirect to login after logout
  };

  useEffect(() => {
    void confirmNewEmail();
  }, []);

  return (
    <ConfirmNewEmail
      confirmationStatus={confirmationStatus}
      onGoToLoginClick={handleGoToLoginClick}
    />
  );
});
